import { MockServicePlanSlot } from "../models/PolePlanGeometry";

/**
 * Plan vectoriel de démonstration.
 *
 * Il ne contient volontairement aucune référence FHIR. Les cinq zones de
 * service et leurs sept emplacements de Location sont des slots géométriques
 * anonymes. Le binding avec les Organization/Location réelles est réalisé à
 * l'exécution par PolePlanGeometryHelper.
 *
 * Les coordonnées utilisent un repère local [x, y] compatible avec
 * L.CRS.Simple. Le plan forme deux ailes séparées par un couloir central.
 */
const MOCK_POLE_PLAN: readonly MockServicePlanSlot[] = [
    {
        id: "service-slot-1",
        locationPolygons: [
            [[0, 82], [14, 82], [14, 98], [0, 98]],
            [[15, 82], [30, 82], [32, 98], [15, 98]],
            [[32, 82], [48, 82], [48, 98], [33, 98]],
            [[0, 65], [17, 65], [17, 81], [0, 81]],
            [[18, 65], [34, 65], [34, 81], [18, 81]],
            [[35, 65], [48, 65], [48, 81], [35, 81]],
            [[0, 52], [48, 52], [48, 64], [30, 64], [30, 60], [18, 60], [18, 64], [0, 64]]
        ]
    },
    {
        id: "service-slot-2",
        locationPolygons: [
            [[52, 82], [68, 82], [68, 98], [52, 98]],
            [[69, 82], [84, 82], [84, 98], [69, 98]],
            [[85, 82], [100, 82], [100, 98], [86, 98]],
            [[52, 65], [71, 65], [71, 81], [52, 81]],
            [[72, 65], [86, 65], [86, 81], [72, 81]],
            [[87, 65], [100, 65], [100, 81], [87, 81]],
            [[52, 52], [100, 52], [100, 64], [79, 64], [79, 59], [66, 59], [66, 64], [52, 64]]
        ]
    },
    {
        id: "service-slot-3",
        locationPolygons: [
            [[104, 82], [120, 82], [120, 98], [104, 98]],
            [[121, 82], [137, 82], [137, 98], [121, 98]],
            [[138, 82], [155, 82], [155, 98], [139, 98]],
            [[104, 65], [122, 65], [122, 81], [104, 81]],
            [[123, 65], [139, 65], [139, 81], [123, 81]],
            [[140, 65], [155, 65], [155, 81], [140, 81]],
            [[104, 52], [155, 52], [155, 64], [145, 64], [145, 60], [118, 60], [118, 64], [104, 64]]
        ]
    },
    {
        id: "service-slot-4",
        locationPolygons: [
            [[82, 25], [100, 25], [100, 42], [82, 42]],
            [[101, 25], [120, 25], [120, 42], [101, 42]],
            [[121, 25], [140, 25], [140, 42], [121, 42]],
            [[141, 25], [155, 25], [155, 42], [141, 42]],
            [[82, 0], [108, 0], [108, 24], [82, 24]],
            [[109, 0], [132, 0], [132, 24], [109, 24]],
            [[133, 0], [155, 0], [155, 24], [146, 24], [146, 19], [133, 19]]
        ]
    },
    {
        id: "service-slot-5",
        locationPolygons: [
            [[0, 25], [18, 25], [18, 42], [0, 42]],
            [[19, 25], [37, 25], [37, 42], [19, 42]],
            [[38, 25], [58, 25], [58, 42], [38, 42]],
            [[59, 25], [78, 25], [78, 42], [59, 42]],
            [[0, 0], [26, 0], [26, 24], [0, 24]],
            [[27, 0], [51, 0], [51, 24], [27, 24]],
            [[52, 0], [78, 0], [78, 24], [65, 24], [65, 19], [52, 19]]
        ]
    }
];

export default MOCK_POLE_PLAN;
